module.exports = __webpack_public_path__ + "media/images/flags/es-a05ccdc39b7acee70c88e037a672c3b8.png";